import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.css';
import App from './App';

// rootエレメントの取得
const rootElement = document.getElementById('root');

// rootエレメントの存在チェック
if (!rootElement) {
    throw new Error('Failed to find the root element');
}

// Reactのルートを作成
const root = createRoot(rootElement);

// アプリケーションのレンダリング
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
